module.exports = __webpack_public_path__ + "2cb4bc0f43efaf444d88a7b55b52ff9e.svg";